import React from 'react';
import PropTypes from 'prop-types';

import { PrimaryLink } from '../../buttons';
import { Languages } from '../../../tools/languages';

import './index.scss';

const Item = ({ name, children }) => {
  return (
    <li>
      <span className="address-item-name">{name}</span>
      <div className="address-item">{children}</div>
    </li>
  );
};

const Address = ({ language }) => {
  if (language === Languages.NL) {
    return (
      <address>
        <ul>
          <Item name="E-mail">
            <PrimaryLink>info@bavak.com</PrimaryLink>
          </Item>
          <Item name="Telefoon">
            <PrimaryLink>071 403 5544</PrimaryLink>
          </Item>
          <Item name="Service">
            <PrimaryLink>071 402 5020</PrimaryLink>
          </Item>
          <Item name="Postbus">
            Postbus 334
            <br />
            2200 AH NOORDWIJK ZH
          </Item>
          <Item name="Openingstijden">
            <table className="table">
              <tbody>
                <tr>
                  <td className="day-row">Maandag:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Dinsdag:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Woensdag:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Donderdag:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Vrijdag:</td>
                  <td>08:00 - 16:30</td>
                </tr>
              </tbody>
            </table>
          </Item>
          <Item name="Service">24&times;7</Item>
        </ul>
      </address>
    );
  } else {
    return (
      <address>
        <ul>
          <Item name="E-mail">
            <PrimaryLink>info@bavak.com</PrimaryLink>
          </Item>
          <Item name="Phone">
            <PrimaryLink>+31 71 403 5544</PrimaryLink>
          </Item>
          <Item name="Service">
            <PrimaryLink>+31 71 402 5020</PrimaryLink>
          </Item>
          <Item name="PO Box">
            PO Box 334
            <br />
            2200 AH NOORDWIJK ZH
          </Item>
          <Item name="Opening Hours">
            <table className="table">
              <tbody>
                <tr>
                  <td className="day-row">Monday:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Tuesday:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Wednesday:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Thursday:</td>
                  <td>08:00 - 16:30</td>
                </tr>
                <tr>
                  <td className="day-row">Friday:</td>
                  <td>08:00 - 16:30</td>
                </tr>
              </tbody>
            </table>
          </Item>
          <Item name="Service">24&times;7</Item>
        </ul>
      </address>
    );
  }
};

Item.propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

Address.propTypes = {
  language: PropTypes.string.isRequired,
};

Address.defaultProps = {
  language: Languages.EN,
};

export default Address;
